var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{},[_c('vue-form',{attrs:{"name":'team-'+_vm.teamId,"fields":_vm.questions},on:{"change":_vm.updateInfo}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }